import { isUndefined } from '@customer/utils/helpers';
interface Settings {
  locale: string;
  lang: string;
  enableSocialLogin: boolean;
}

type SettingsKeys = keyof Settings;

type GetPortalLoginSettings = <K extends SettingsKeys | 'config'>(key?: K) => K extends SettingsKeys ? Settings[K] : Settings;

let globalPortalLoginSettings: () => typeof defaultSettings | null = () => {
  return null;
};

const defaultSettings = {
  locale: 'lt_LT',
  lang: 'lt',
  enableSocialLogin: true,
};

function setPortalLoginSettings(config: Partial<Settings>) {
  const settings = {
    locale: !isUndefined(config.locale) ? (config.locale as string) : defaultSettings.locale,
    lang: !isUndefined(config.lang) ? (config.lang as string) : defaultSettings.lang,
    enableSocialLogin: !isUndefined(config.enableSocialLogin) ? (config.enableSocialLogin as boolean) : defaultSettings.enableSocialLogin,
  };

  globalPortalLoginSettings = () => {
    return settings;
  };
}

const getPortalLoginSettings: GetPortalLoginSettings = (key) => {
  const settings = globalPortalLoginSettings() || defaultSettings;
  const noKey = !key || key === 'config';
  // @ts-ignore
  return noKey ? settings : settings[key];
};

export { setPortalLoginSettings, getPortalLoginSettings, Settings };
